import { useState, useEffect, useMemo, useCallback } from 'react'
import { Button, Col, FormGroup, Input, Label, FormFeedback } from 'reactstrap'

import { getUUID } from 'components/common/utils'

import type { ChangeEvent, FocusEvent } from 'react'

type InputFormProps = {
  label: string | JSX.Element
  disabledAddressAutoInput: boolean
  onChange: (value: string) => void
  onAddressAutoInput: () => void
  value?: string
  validations?: Array<(s: string | undefined) => string>
  onValidate?: (b: boolean) => void
}

export const PostalCodeInputForm = ({
  label,
  disabledAddressAutoInput,
  onChange,
  onAddressAutoInput,
  value,
  validations,
  onValidate,
}: InputFormProps) => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>('')

  const invalid = useCallback(
    (inputValue: string | undefined) => validations?.find(validation => validation(inputValue))?.(inputValue),
    [validations]
  )

  useEffect(() => {
    setErrorMessage(invalid(value))
  }, [invalid, value])

  const handleChange = (e: ChangeEvent<HTMLInputElement> | FocusEvent<HTMLInputElement>) => onChange(e.target.value)

  const id = useMemo(() => `id-${getUUID()}`, [])

  // 直接onValidateを実行すると親のrender中に子コンポーネントから状態を変えることになりwarningが出る
  useEffect(() => onValidate?.(!errorMessage), [onValidate, value, errorMessage])
  return (
    <>
      <FormGroup row>
        <Label for={id} md={4}>
          {label}
        </Label>
        <Col md={4} className="align-self-center">
          <Input
            value={value || ''}
            invalid={!!errorMessage}
            maxLength={7}
            id={id}
            placeholder="郵便番号を入力"
            onChange={handleChange}
            onBlur={handleChange}
          />
          <FormFeedback hidden={!errorMessage}>{errorMessage}</FormFeedback>
          <div className="text-muted">ハイフンなしで入力してください</div>
        </Col>
        <Col>
          <Button outline color="dark" disabled={disabledAddressAutoInput} onClick={onAddressAutoInput}>
            住所検索
          </Button>
        </Col>
      </FormGroup>
    </>
  )
}
